var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchArrowNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 23.1383C2.1 23.3383 1.625 23.2946 1.175 23.0071C0.725 22.7196 0.5 22.3008 0.5 21.7508V15.0008L12.5 12.0008L0.5 9.00081V2.25081C0.5 1.70081 0.725 1.28206 1.175 0.994561C1.625 0.707061 2.1 0.663311 2.6 0.863311L25.7 10.6133C26.325 10.8883 26.6375 11.3508 26.6375 12.0008C26.6375 12.6508 26.325 13.1133 25.7 13.3883L2.6 23.1383Z",
    fill: "#50B848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchArrowNew);
export default __webpack_public_path__ + "static/media/search_arrow_new.f9d32b5eee2ca60d1f90526f774b09eb.svg";
export { ForwardRef as ReactComponent };